import { Injectable } from '@angular/core';
import { elementStyle } from '@angular/core/src/render3/instructions';
import { AuthService } from '@app/auth.service';
import { ApiService } from 'app/utility/api.service';
interface isLoggedIn {
  status: boolean
}

interface logoutStatus {
  status: boolean
}

@Injectable()
export class UserService {

  constructor(
    private Auth: AuthService,
    private Api: ApiService
  ) { }

  isLoggedIn() {
    const result: isLoggedIn = {
      status: false
    };

    const member_info = JSON.parse(sessionStorage.getItem('member_obj'));
    if (member_info != null) {
      if (member_info.member_no != '') {
        result.status = true;
      }
    }
    return result;
  }

  logout() {
    sessionStorage.setItem('member_obj', null);
    sessionStorage.setItem('current_page_permiss', null);
    this.Auth.setLoggedIn(false);
    const result: isLoggedIn = {
      status: true
    };
    return result;
  }

  async ChangePassword(User: string, OldPassword: string, NewPassword: string) {
    var req: any = {};
    req['oldPassword'] = OldPassword;
    req['newPassword'] = NewPassword;
    req['forcechangepassword'] = false;
    return await this.Api.put("crmservice", "agentbankChangePassword/" + User, req);
  }

  IsValidatePassword(Password: string): boolean {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&\'()*+,-./:;<=>?@[\]^_`{|}])[A-Za-z\d!"#$%&\'()*+,-./:;<=>?@[\]^_`{|}]{8,16}$/.test(Password);
  }
}



// WEBPACK FOOTER //
// ./src/app/user.service.ts